import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

function setCssVariablesOnRoot(vars: Record<string, string>) {
  const styleId = 'dynamic-css-vars-root';
  let styleTag = document.getElementById(styleId) as HTMLStyleElement | null;

  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = styleId;
    document.head.appendChild(styleTag);
  }

  const cssVars = Object.entries(vars)
    .map(([key, val]) => `${key}: ${val};`)
    .join('\n  ');

  styleTag.textContent = `:root {\n  ${cssVars}\n}`;
}

// todo разобраться, что это за фунция, дергающаяся как компонент, но с return null
export function CssVarsProvider() {
  const theme = useTheme();

  /**
   * Функция для рекурсивного обхода объекта палитры
   * Формирует переменные для scss, пример использования --palette-primary-main
   */
  useEffect(() => {
    function flattenPalette(obj: object, prefix = '--palette'): Record<string, string> {
      const vars: Record<string, string> = {};

      Object.entries(obj).forEach(([key, val]) => {
        if (typeof val === 'string') {
          vars[`${prefix}-${key}`] = val;
        } else if (typeof val === 'object' && val !== null) {
          Object.assign(vars, flattenPalette(val, `${prefix}-${key}`));
        }
      });

      return vars;
    }

    const cssVars = flattenPalette(theme.palette);

    setCssVariablesOnRoot(cssVars);
  }, [theme]);

  return null;
}